import React from 'react';
import { ReactComponent as IconMoney } from '../../../assets/icons/icon-cash.svg';

const NotifPromo = () => {
  return (
    <>
      {/* Start Item Notif */}
      <div className="flex bg-line-orange-100 px-6 py-4 flex-no-wrap cursor-pointer">
        <div className="flex rounded-full p-2 h-12 w-24 bg-basic-orange-16% items-center justify-center">
          <IconMoney className="h-6 w-6" />
        </div>
        <div className="flex flex-col mx-4 flex-grow">
          <div className="flex w-full justify-between mb-2">
            <h5 className="text-font-gray font-semibold">
              Promo Diskon Ongkir
            </h5>
            <p className="text-sm opacity-50 text-font-gray">7:40</p>
          </div>
          <p className="text-sm text-font-gray-light">
            Plus JBL Earphone jadi 88RB & Veger Powerbank 10000mAh jadi 107RB.
            Beli semua di Elektronik harga terbaik!
          </p>
        </div>
      </div>
      {/* End Item  Notif */}
      {/* Start Item Notif */}
      <div className="flex bg-line-orange-100 px-6 py-4 flex-no-wrap cursor-pointer">
        <div className="flex rounded-full p-2 h-12 w-24 bg-basic-orange-16% items-center justify-center">
          <IconMoney className="h-6 w-6" />
        </div>
        <div className="flex flex-col mx-4 flex-grow">
          <div className="flex w-full justify-between mb-2">
            <h5 className="text-font-gray font-semibold">
              Promo Diskon Ongkir
            </h5>
            <p className="text-sm opacity-50 text-font-gray">7:40</p>
          </div>
          <p className="text-sm text-font-gray-light">
            Klaim EKSTRA 1 Voucher Gratis Ongkir s/d 50RB khusus Shopee Express,
            untuk SEMUA metode pembayaran di SEMUA Toko.
          </p>
        </div>
      </div>
      {/* End Item  Notif */}
    </>
  );
};

export default NotifPromo;
